import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone, ChevronDown } from "lucide-react";

const TOUR_LINKS = [
  { to: "/tours?category=Group%20Tours", label: "Group Tours" },
  { to: "/tours?category=Customized%20Tours", label: "Customized Tours" },
];

const navAfter = [
  { to: "/gallery", label: "Gallery" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const linkClass = ({ isActive }) =>
    `px-4 py-2 rounded-full text-[15px] font-semibold transition-colors ${
      isActive ? "bg-warm-surface text-maroon" : "text-slate-700 hover:text-maroon hover:bg-warm-surface"
    }`;

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b-2 border-amber-500/40">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="brand-logo">
          <img src="/logo.jpg" alt="Global Compass Tours & Travels — Your Dream Holiday @ Dream Price" className="h-12 sm:h-14 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          <NavLink to="/" end className={linkClass} data-testid="nav-home">Home</NavLink>
          <div className="relative group" data-testid="nav-tours-dropdown">
            <NavLink to="/tours" className={({ isActive }) =>
              `px-4 py-2 rounded-full text-[15px] font-semibold transition-colors inline-flex items-center gap-1 ${
                isActive ? "bg-warm-surface text-maroon" : "text-slate-700 hover:text-maroon hover:bg-warm-surface"
              }`} data-testid="nav-tours">
              Tours <ChevronDown size={15} className="transition-transform group-hover:rotate-180" />
            </NavLink>
            <div className="absolute left-0 top-full pt-2 hidden group-hover:block min-w-[210px]">
              <div className="bg-white rounded-xl shadow-xl border border-amber-900/10 py-2 overflow-hidden">
                {TOUR_LINKS.map((t) => (
                  <Link key={t.to} to={t.to} className="block px-5 py-2.5 text-[15px] font-semibold text-slate-700 hover:bg-warm-surface hover:text-maroon transition-colors"
                    data-testid={`nav-tours-${t.label.toLowerCase().replace(/\s/g, "-")}`}>{t.label}</Link>
                ))}
              </div>
            </div>
          </div>
          {navAfter.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkClass} data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>{n.label}</NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href="tel:+919874250100" className="btn-maroon px-6 h-11 rounded-full font-semibold text-[15px] inline-flex items-center gap-2" data-testid="header-call-btn">
            <Phone size={16} /> Call
          </a>
        </div>
        <button className="lg:hidden text-maroon" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-amber-900/10 bg-white">
          <div className="px-4 py-3 flex flex-col gap-1">
            <NavLink to="/" end onClick={() => setOpen(false)}
              className={({ isActive }) => `px-4 py-3 rounded-lg text-base font-semibold ${isActive ? "bg-warm-surface text-maroon" : "text-slate-700"}`}
              data-testid="mobile-nav-home">Home</NavLink>
            <div className="px-4 pt-2 pb-1 text-xs font-bold uppercase tracking-widest text-amber-700">Tours</div>
            {TOUR_LINKS.map((t) => (
              <Link key={t.to} to={t.to} onClick={() => setOpen(false)}
                className="px-6 py-3 rounded-lg text-base font-semibold text-slate-700"
                data-testid={`mobile-nav-tours-${t.label.toLowerCase().replace(/\s/g, "-")}`}>{t.label}</Link>
            ))}
            {navAfter.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)}
                className={({ isActive }) => `px-4 py-3 rounded-lg text-base font-semibold ${isActive ? "bg-warm-surface text-maroon" : "text-slate-700"}`}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>{n.label}</NavLink>
            ))}
            <a href="tel:+919874250100" className="btn-maroon px-5 h-12 rounded-full font-semibold mt-2 inline-flex items-center justify-center gap-2" data-testid="mobile-call-btn">
              <Phone size={16} /> Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
